// UserAllocDict.js
// DbdbTap 2024-09-23 11:36:25
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    userAllocSeq : {
		id: 'userAllocSeq', required: true, toAdd: false, toEdit: true,
	},
    userId : {
		id: 'userId', label: '사용자ID',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '25자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 25)},
	},
    userName : {
		id: 'userName', label: '이름',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '128자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 128)},
	},
    password : {
		id: 'password', label: '암호',
		type: InputType.text, required: true, toAdd: true, toEdit: false,
		help: '대문자,소문자,숫자,기호 중 3가지 이상 섞어 8자 이상(개인정보보호법).',
		check: (value) => {return IsValid.passwordStrict(value)},
	},
    passwordConfirm: {
        id: 'passwordConfirm', label: '암호확인',
        type: InputType.text, required: false, toAdd: false, toEdit: true,
        help: '암호와 동일하게 입력하세요.',
    },
    zipCd : {
		id: 'zipCd', label: '우편번호',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 7)},
	},
    addr : {
		id: 'addr', label: '주소',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 120)},
	},
    telno : {
		id: 'telno', label: '연락처',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 15)},
	},
    /* mobile : {
		id: 'mobile', label: 'mobile',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '64자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 64)},
	}, */
    email : {
		id: 'email', label: '메일주소',
		type: InputType.email, required: false, toAdd: true, toEdit: true,
		help: '형식에 맞도록 메일주소를 입력하세요.',
		check: (value) => {return IsValid.nullString(value) || IsValid.email(value)},
	},
    authClassId : {
		id: 'authClassId', label: '권한',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
	},
    dcCd : {
		id: 'dcCd', label: '소속DC',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
	},
    storeId : {
		id: 'storeId', label: '소속점포',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
	},
    comId : {
		id: 'comId', label: '소속운송사',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
	},
    /* allocTypeCd : {
		id: 'allocTypeCd', label: 'allocTypeCd',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '5자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 5)},
	}, */
    allocIp : {
		id: 'allocIp', label: '승인요청IP',
	},
    /* allocFlag : {
		id: 'allocFlag', label: 'allocFlag',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, */
    allocDate : {
		id: 'allocDate', label: '신청일',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
	},
    allDc : {
		id: 'allDc', label: 'DC상태전환',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
	},
    note : {
		id: 'note', label: '거절사유',
		type: InputType.text, required: false, toAdd: false, toEdit: false,
	},
    className : {
		id: 'className', label: '권한',
	},
    dcName : {
		id: 'dcName', label: '소속DC',
	},
    comName : {
		id: 'comName', label: '소속운송사',
	},
    storeName : {
		id: 'storeName', label: '소속점포',
	},
    allocType: { id: 'allocType', label: '승인요청', },
    allocFlagLabel: { id: 'allocFlagLabel', label: '처리상태', }
};

/**
 * USER_ALLOC React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-09-23 11:36:25 using DbdbTap
 */
export const UserAllocDictionary = {
    inputMap: Dict,
    value: {
        Allow:'1', Deny:'2', Wait:'0', // from code info.
    },
    permitInputMap: {
        userAllocSeq: Dict.userAllocSeq,
        permit: {
            id: 'permit', label: '허가',
            type: InputType.checkbox, required: true, toAdd: false, toEdit: true,
        },
        note: Dict.note,
    },
    reuseInputMap: {
        userId: Dict.userId,
        password: Dict.password,
    },
    errorTitle: {
        Add: '승인요청 등록 오류',
        Edit: '승인요청 수정 오류',
        Remove: '승인요청 삭제 오류',
        Get: '승인요청 조회 오류',
        Permit: '승인요청 허가 오류',
    },
    tableProps: {
        tableId: 'userAllocTable',
        uniqueKey: 'userAllocSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
            styles: [
                {
                    when: (row) => row.allocFlag === '0', // Wait
                    style: { color: '#00f'}
                },
                {
                    when: (row) => row.allocFlag === '2', // Reject
                    style: { color: '#f00'}
                }
            ]
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'userAllocSeq', label: Dict.userAllocSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'userId', label: Dict.userId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'userName', label: Dict.userName.label, width: 90, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'password', label: Dict.password.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'className', label: Dict.className.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: Dict.dcName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeName', label: Dict.storeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: Dict.comName.label, width: 150, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'zipCd', label: Dict.zipCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'addr', label: Dict.addr.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'telno', label: Dict.telno.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'mobile', label: Dict.mobile.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'allDc', label: Dict.allDc.label, width: 100, show: true, option:{align: 'center', print: (r,i,v)=>v?'전체':'소속DC구분'} },
            { id: 'allocType', label: Dict.allocType.label, width: 80, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'allocFlagLabel', label: Dict.allocFlagLabel.label, width: 70, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'note', label: Dict.note.label, width: 200, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'allocDate', label: Dict.allocDate.label, width: 130, show: true, option:{align: 'inherit', print:(r,i,v)=>ValueMisc.substr(v,0,16)} },
            { id: 'regDate', label: "등록일", width: 130, show: true, option:{align: 'inherit', print:(r,i,v)=>ValueMisc.substr(v,0,16)} },
            { id: 'regUserName', label: "등록자", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'allocIp', label: Dict.allocIp.label, width: 90, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
